module.exports = __webpack_public_path__ + "img/55.ff258dc2.jpg";